import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

export const DEFAULT_CMS_HEADING_TAG_LEVEL = 3;

@Component({
  selector: 'fcom-heading-tag',
  templateUrl: './heading-tag.component.html',
  styleUrls: ['./heading-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgTemplateOutlet],
})
export class HeadingTagComponent {
  extraClasses = input<string>();
  level = input<number | undefined>(DEFAULT_CMS_HEADING_TAG_LEVEL);
}
